// extracted by mini-css-extract-plugin
export default {"failure_payment_modal":"paymentFailure_failure_payment_modal__ihYmk"};